import React from 'react';
import { BatteryCharging } from 'lucide-react';
import ChartCard from './ChartCard';

const Stat = ({ label, value, testId }) => (
  <div>
    <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground mb-1">{label}</p>
    <p className="font-mono text-base font-bold text-autoxium-blue" data-testid={testId}>{value}</p>
  </div>
);

/**
 * Battery Requirement (§5): pack sizing outputs. Cells in Parallel is the larger of the
 * strings needed to store the range energy and the strings needed to deliver the motor's
 * peak power ("Strings Sized By"), plus the Additional Battery Strings input (see
 * backend/simulation/battery.py::size_battery_pack). Pack Voltage Range is the resting
 * (open-circuit) voltage at Minimum and Maximum SoC.
 */
const BatteryRequirementPanel = ({ batteryRequirement: br }) => {
  if (!br) return null;

  return (
    <ChartCard icon={BatteryCharging} title="Battery Requirement" testId="battery-requirement-panel">
      <div className="grid sm:grid-cols-3 lg:grid-cols-5 gap-4">
        <Stat label="Pack Voltage Range" value={`${br.pack_voltage_min_v.toFixed(0)}-${br.pack_voltage_max_v.toFixed(0)} V`} testId="br-pack-voltage-range" />
        <Stat label="Pack Capacity" value={`${br.pack_capacity_ah.toFixed(1)} Ah`} testId="br-pack-capacity" />
        <Stat label="Total Energy Required" value={`${br.total_energy_required_kwh.toFixed(1)} kWh`} testId="br-total-energy" />
        <Stat label="Cells in Series" value={br.cells_in_series} testId="br-cells-series" />
        <Stat label="Cells in Parallel" value={br.cells_in_parallel} testId="br-cells-parallel" />
        <Stat label="Total Cells" value={br.total_cells.toLocaleString()} testId="br-total-cells" />
        <Stat label="Energy per Cell" value={`${br.energy_per_cell_wh.toFixed(1)} Wh`} testId="br-energy-per-cell" />
        <Stat label="Usable Energy" value={`${br.usable_energy_kwh.toFixed(1)} kWh`} testId="br-usable-energy" />
        <Stat label="Total Battery Pack Mass" value={`${br.total_pack_mass_kg.toFixed(0)} kg`} testId="br-pack-mass" />
        <Stat label="Max. Discharge Power" value={`${br.pack_max_discharge_power_kw.toFixed(0)} kW`} testId="br-max-discharge-power" />
        <Stat label="Max. Regen Power" value={`${br.pack_max_regen_power_kw.toFixed(0)} kW`} testId="br-max-regen-power" />
        <Stat label="Peak Pack Current" value={`${br.peak_pack_current_a.toFixed(0)} A`} testId="br-peak-current" />
        <Stat label="Strings Sized By" value={br.strings_governed_by === 'power' ? 'Peak power' : 'Range energy'} testId="br-governed-by" />
      </div>
    </ChartCard>
  );
};

export default BatteryRequirementPanel;
